import "./css/style.css"

export default function AlliumLoadingScreen() {

    return (
        <div id={"alliumLoadingScreen"}>
            <div className={"loader"}>
                <span className={"load-1 load"}/>
                <span className={"load-2 load"}/>
                <span className={"load-3 load"}/>
            </div>
        </div>
    );
}